import React, { useState, useContext } from 'react';
import { ApolloProvider } from '@apollo/client';
import styled from 'styled-components';

import logo from '../../Logo.png';
import AuthContext from '../../contexts/AuthContext';
import { textGray } from '../../styles/colors';

import Login from './Login';
import AcceptInvite from './AcceptInvite';
import Choose from './Choose';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const Screen = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Header = styled.div`
  height: 100px;
  padding: 65px;

  @media (max-width: 480px) {
    padding-left: 5%;
    padding-right: 5%;

    > img {
      width: 90%;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 100px;
  animation: fadeIn 1s;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 65px;
  justify-content: center;
`;

const FooterLink = styled.a`
  text-align: center;
  text-decoration: none;
  color: ${textGray};
`;

const Auth = () => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const {
    apolloClientForAuth,
    isLoggedIn,
    ownerPortalUserId,
    ownerPortalUsersCount,
    loginAttempted,
    dataLoaded
  } = useContext(AuthContext);

  const params = new URLSearchParams(window.location.search);
  const inviteToken = params.get('inviteToken');
  const resetToken = params.get('resetToken');

  let content = <Login
    setShowForgotPassword={setShowForgotPassword}
    noPortalUsers={loginAttempted && dataLoaded && (ownerPortalUsersCount < 1 ||
      ownerPortalUsersCount === undefined)
    }
  />;

  if (showForgotPassword) {
    content = <ForgotPassword setShowForgotPassword={setShowForgotPassword} />;
  } else if (resetToken) {
    content = <ResetPassword token={resetToken} />;
  } else if (inviteToken) {
    content = <AcceptInvite token={inviteToken} />;
  } else if (isLoggedIn && !ownerPortalUserId && ownerPortalUsersCount > 1) {
    content = <Choose />;
  }

  return (
    <ApolloProvider client={apolloClientForAuth}>
      <Screen>
        <Header>
          <img src={logo} alt="Fly Louie" />
        </Header>

        <Content>
          {content}
        </Content>

        <Footer>
          <FooterLink href="/">Terms of Service</FooterLink>
          <FooterLink href="/">Privacy Policy</FooterLink>
          <FooterLink href="mailto:fuel@flylouie.com">Contact Us</FooterLink>
        </Footer>
      </Screen>
    </ApolloProvider>
  );
};

export default Auth;
